// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"QzL8TZqoE1L2mCesq4ots","container":"_2r_wxLwlCgs9kXBopgVkJa","logo":"_2d7NtxvYLth6WMJAl6GSaq","logo-initials":"_1-0H5DAkwfHuIdOgs3TfhC","logoInitials":"_1-0H5DAkwfHuIdOgs3TfhC","logo-name":"_3d5yAuwsgL7YtoFNxA_hF_","logoName":"_3d5yAuwsgL7YtoFNxA_hF_","logoTitle":"_3Em23Cu0ofXb4qGAgkFCk_","logo-subname":"_70axXp76dqYyHZcCqmmyW","logoSubname":"_70axXp76dqYyHZcCqmmyW"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Logo/styles.scss
 ** module id = 446
 ** module chunks = 0
 **/